import {
  ROUTE_USERS,
  ROUTE_USERS_MY_USERS,
  ROUTE_USER_CREATE,
  ROUTE_USER_EDIT,
  ROUTE_USER_PLAYTHROUGHS,
} from '@/router/routes/routeNames'

const UserEdit = () => import('@/components/user/edit/UserEditView.vue')
const UserCreate = () => import('@/components/user/UserCreateView.vue')
const Users = () => import('@/components/user/UsersView.vue')
const UserPlaythroughs = () =>
  import('@/components/user/edit/playthroughs/UserPlaythroughsView.vue')

const userRoutes = [
  {
    name: ROUTE_USERS,
    path: '/users',
    redirect: { name: ROUTE_USERS_MY_USERS },
    component: Users,
    meta: { resource: 'User', showGlobalHeader: false },
  },
  {
    name: ROUTE_USERS_MY_USERS,
    path: '/users/my-users',
    component: Users,
    meta: { resource: 'User', showGlobalHeader: false },
  },
  {
    name: ROUTE_USER_CREATE,
    path: '/users/my-users/create',
    component: UserCreate,
    props: true,
    meta: { resource: 'User' },
  },
  {
    name: ROUTE_USER_EDIT,
    path: '/users/my-users/:userId',
    component: UserEdit,
    props: true,
    meta: { resource: 'User' },
  },
  {
    name: ROUTE_USER_PLAYTHROUGHS,
    path: '/users/my-users/:userId/products',
    component: UserPlaythroughs,
    props: true,
    meta: { resource: 'User' },
  },
]

export default userRoutes
